import { gql } from '@apollo/client';

import type { OrderReturnReasonsQuery } from '../__graphql__/useOrderReturnReasons';
import { useOrderReturnReasonsQuery } from '../__graphql__/useOrderReturnReasons';

export interface ReturnReason {
  attributeCode: string;
  attributeType: string;
  attributeOptions: Array<{
    label: string;
    value: string;
  }>;
}

function transformOrderReturnReasonsQuery(
  orderReturnReasonsQuery: OrderReturnReasonsQuery,
) {
  const items =
    orderReturnReasonsQuery?.magento2?.customAttributeMetadata?.items;

  if (!items) {
    return [];
  }

  return items.map((item) => ({
    attributeCode: item?.attributeCode ?? '',
    attributeType: item?.attributeType ?? '',
    attributeOptions: (item?.attributeOptions ?? [])
      .filter((option) => option?.label && option?.value)
      .map((option) => ({
        label: option?.label ?? '',
        value: option?.value ?? '',
      })),
  }));
}

const useReturnRequestReasons = () => {
  const { data, loading, error } = useOrderReturnReasonsQuery({ ssr: false });
  const transformedData = data ? transformOrderReturnReasonsQuery(data) : [];

  const mergedReasons = transformedData.flatMap((reasonGroup) =>
    reasonGroup.attributeOptions.map((options) => ({
      ...options,
      attributeCode: reasonGroup.attributeCode,
    })),
  );

  return {
    loading,
    error,
    returnReasons: mergedReasons,
  };
};

export default useReturnRequestReasons;

export const ORDER_RETURN_REASONS = gql`
  query OrderReturnReasons {
    magento2 {
      customAttributeMetadata(
        attributes: [
          { attribute_code: "reason", entity_type: "rma_item" }
          { attribute_code: "reason_other", entity_type: "rma_item" }
        ]
      ) {
        items {
          attributeCode
          attributeType
          attributeOptions {
            label
            value
          }
        }
      }
    }
  }
`;
